import { TEXT } from "../consts/style";
import styled, { StyledComponentClass } from "styled-components";
import {
  Link,
  LinkProps
} from "@origin-digital/style-guide/dist/lib/components/Link";

const StyledLink: StyledComponentClass<LinkProps, any> = styled(Link)`
  color: ${TEXT.LINK.STATIC};
  text-decoration: none;
  font-size: 14px;
  &:hover {
    color: ${TEXT.LINK.HOVER};
  }

  &:hover > svg {
    fill: ${TEXT.LINK.HOVER};
  }
`;

export { LinkProps, Link, StyledLink };
